import { Component } from '@angular/core';

@Component({
    selector: 'app-splashscreen',
    templateUrl: './splashscreen.component.html',
    standalone: false
})
export class SplashscreenComponent {

}
